<div class="container" style="margin-top: 2em;">
    <h2>Services </h2>
    <p>
        The company offers the ‘complete building service‘ covering all aspects of domestic building throughout East Sussex, south west Kent & south east Surrey. The company works closely with 
        regular architects &amp; structural engineers &amp; can offer a full architectural design service to include:
    </p>
    <ul>
        <li>all drawing work,</li>
        <li>planning applications,</li>
        <li>structural design,</li>
        <li>full building regulation applications.</li>
    </ul>

    <div class="card align-content-center text-center mx-auto d-block image">
        <img src="/assets/images/Van.jpg" class="card-img-top img-fluid center" alt="Jon Ray Building - high quality property renovation in Sussex and Kent">
    </div>

    <p>
        Works to listed property is also carried out, in obtaining listed building consent 
        &amp; if necessary heritage statements on period property.
    </p>
    <p>
        Along with these professional services the company offers, it also takes responsibility for all building trades from:
    </p>
    <ul>
        <li>groundworks, drainage installations &amp; landscaping,</li>
        <li>brickwork/stonework,</li>
        <li>steelwork,</li>
        <li>1st/2nd fix carpentry from a new door or floor to a complete traditionally ‘cut &amp; pitched roof ‘,</li>
        <li>bespoke joinery including windows, doors, staircases &amp; built-in furniture,</li>
        <li>all roofing types including traditional leadwork and guttering,</li>
        <li>plumbing &amp; heating,</li>
        <li>electrical services,</li>
        <li>plastering,</li>
        <li>interior &amp; exterior decorating,</li>
        <li>interior tiling,</li>
        <li>phone-internet &amp; home entertainment systems.</li>
    </ul>              

    <p>
        Jon Ray Building Ltd undertakes renovation, extension &amp; conversion projects of varying sizes, many on older &amp; larger domestic properties
        (including listed buildings), others on modern property, with steel framing, with large areas of glazing. Whether it is a tired kitchen-diner, full house renovation, new porch, 
        large 3-storey house extension, a garage, loft, to a complete agricultural building conversion; all works are competently undertaken &amp; clients requirements met &amp; 
        accommodated. Fully bespoke, well appointed, sunrooms/orangeries, roof terraces, balconies, kitchens &amp; bathrooms, are also regularly designed &amp; constructed.                                 
        The company also carries out regular building maintenance covering the needs of its clients old &amp; new. 
        Whether it’s for a dripping tap, a leaking roof, a rotten window frame or the rebuilding of a leaking/structurally unsound chimney stack, 
        or its simply time for that annual redecoration work, Jon Ray Building Ltd has it covered for you. The construction of new buildings is also undertaken.                  
    </p>

    <div class="card align-content-center text-center mx-auto d-block image image-portrait">
      <img src="/assets/images/Portfolio/023b.jpg" class="card-img-top img-fluid center" alt="Jon Ray Building - high quality property renovation in Sussex and Kent">
    </div>

    <p>
        The <a routerLink="/portfolio">portfolio</a> shows some images of various jobs to give you a flavour of what Jon Ray Building Ltd can do &amp; is hopefully indicative 
        of the quality of work the company seeks to provide to all its clients. In addition, once a perspective client is ready to sign up on a new project, if references are required, 
        a client can by special request ask to speak to current, previous or long-term existing clients about their experience with the company.                                                                                                                
        The majority of work Jon Ray Building Ltd carries out comes from personal recommendation. 
        The company believes &amp; generally finds, if you leave the customer happy, they will in the future be content to carry on using the services provided &amp; 
        be happy to give a positive reference.   
    </p>

    <p style="font-weight: bold;">
        Jon Ray Building Ltd aspires to deliver complete customer satisfaction with an honest, considered &amp; conscientious approach to all building works carried out. 
        Jon Ray sees this as key to the success of the company &amp; more importantly, the satisfaction of their clients.   
    </p> 
</div>
